import { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { QuickBooksDashboard } from "./QuickBooksDashboard";

// Removed hardcoded CLIENT_ID and REDIRECT_URI - now using backend endpoint

const QuickBooksLogin = () => {
  const [loading, setLoading] = useState(true);
  const [firstTime, setFirstTime] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

  const retrieveToken = async () => {
    const isValid = await checkTokenValidity();

    if (isValid) {
      setLoggedIn(true);
      setLoading(false);
    }
    else {
      setLoading(false);
      setLoggedIn(false);
    }
  }

  useEffect(() => {
    if(firstTime) {
      retrieveToken();
      setFirstTime(false);
    }
    const handleMessage = (event) => {
      if (event.data === "quickbooks-auth-success") {
        retrieveToken();
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleLogin = async () => {
    localStorage.removeItem("quickbooks_token");
    await redirectToQuickBooksAuth();
  }

  const checkTokenValidity = async () => {
    try {
      const response = await axios.get(
        "/assignments/check-status/",
        { withCredentials: true }
      );

      return response.connected && response.valid;
    } catch (error) {
      console.error("Error checking token validity:", error);
      return false;
    }
  };

  const redirectToQuickBooksAuth = async () => {
    try {
      // Get auth URL from backend (Best Practice: Backend generates URL)
      const response = await axios.get(
        "/assignments/connect/",
        { withCredentials: true }
      );

      if (response.success && response.auth_url) {
        window.open(response.auth_url, "_blank", "width=600,height=700");
      } else {
        alert('Failed to get QuickBooks authorization URL. Please try again.');
      }
    } catch (error) {
      console.error('Error initiating QuickBooks login:', error);
      alert('Failed to initiate QuickBooks login. Please try again.');
    }
  };

  return (<>

    {(loading || !loggedIn) && (<Container fluid style={{ width: "100%", height: "10vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Row>
        <Col xl={12}>
          {(loading) && (<div>Loading...</div>)}
          {(!loading && !loggedIn) &&
            <Button color="primary" className="mt-3" onClick={handleLogin}>Login to QuickBooks</Button>
          }
        </Col>
      </Row>
    </Container>)}

    {(!loading && loggedIn) && <QuickBooksDashboard onDisconnect={retrieveToken} />}
  </>)
};

export default QuickBooksLogin;